export default __webpack_public_path__ + "static/logo_white_bg-1ba39a3fbd44b7d0986d97cdfa878079.png";